import i18n from 'i18next'

import { initReactI18next } from 'react-i18next'

import translationsNL from './locales/nl/translation.json'

export const defaultNamespace = 'translations'
export type AppNamespace = Record<'translations', never>
export const resources = {
  nl: { translations: translationsNL },
}

i18n.use(initReactI18next).init({
  lng: 'nl',
  fallbackLng: ['nl'],
  supportedLngs: ['nl'],
  keySeparator: '.',
  ns: [defaultNamespace] as (keyof AppNamespace)[],
  resources,
  returnEmptyString: false,
})

export default i18n
